import {Component, ViewEncapsulation} from '@angular/core';
import {LangService, LoaderService, NavigateService} from 'ngx-satoris';
import {ApiService} from '../../shared/services/api.service';
import {DocumentType} from '../../shared/models/user';
import {documentTypeIsVisa} from 'src/app/shared/models/document-type-helpers';

declare const window: Window & {initialQueryString: string[][]};

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent {

  backOffice = this.api.isElectronApp || localStorage.getItem('backOffice');

  constructor(public nav: NavigateService, public api: ApiService, private loader: LoaderService, private lang: LangService) {
    const firstHolder = window.initialQueryString.find((q: string[]) => q[0] === 'first');
    const autotest = window.initialQueryString.find((q: string[]) => q[0] === 'autotest');
    if(firstHolder && firstHolder[1] === 'true') {
      this.loader.loading(true, {type: 'valid', message: this.lang.transform('home.first')});
    }
    if(autotest) {
      this.loader.customLoadingElement = `
      <div class="element_loader">
        <img width="120px" height="120px" src="assets/logo-square.png" alt="loader" style="border-radius: 100%">
      </div>`;

      const body = document.querySelector('body');
      if(body) body.classList.add('autotest');
    }
  }

  openMailto() {
    window.location.href = `mailto:${this.api.env.supportContactEmail}`;
  }

  protected readonly DocumentType = DocumentType;
  documentTypeIsVisa = documentTypeIsVisa;
}
